import { WarningCircleIcon } from "@phosphor-icons/react";

export default function Disclaimer() {
  return (
    <section
      id="disclaimer"
      data-testid="disclaimer-section"
      className="py-24 md:py-32 bg-[#f3efe6]"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="rounded-3xl border border-stone-200 bg-[#f7f4ec] p-10 md:p-14">
          <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-stone-900 text-[#f7f4ec] mb-6">
            <WarningCircleIcon size={22} weight="duotone" />
          </div>

          <p className="text-sm uppercase tracking-[0.18em] font-semibold text-stone-500">
            Important disclaimer
          </p>
          <h2 className="mt-3 font-heading text-3xl md:text-4xl tracking-tight font-medium text-stone-900 leading-[1.15]">
            What Ranq improves.
            <span className="block text-stone-500">And what it does not promise.</span>
          </h2>

          <p className="mt-6 text-lg leading-relaxed text-stone-700">
            Ranq does not guarantee rankings, recognitions, band promotions or
            results before Chambers &amp; Partners, The Legal 500 or any other
            legal directory. Ranking decisions belong exclusively to each
            directory and its research process. Ranq helps firms strengthen
            what they can control: the quality, structure, consistency and
            clarity of their submission.
          </p>
        </div>
      </div>
    </section>
  );
}
